import { useContext, useMemo } from 'react';
import { useProject } from './api-hooks/useProject';
import { appLog } from '~src/utils/log';
import AppContext from '~src/contexts/AppContext';

/** @returns if current user is super user */
export const useIsSuperuser = () => {
  const project = useProject({ enabled: false });

  const isSuperuser = useMemo(() => !!project.data?.is_superuser, [project]);
  return isSuperuser;
};

// returns boolean if user is in admin mode
export const useIsAdministrationMode = (): boolean => {
  const { appContextState } = useContext(AppContext);

  // AppContext flag (see Settings.tsx)
  if (appContextState === 'super-user') {
    return true;
  }

  // Fallback on sessionStorage (also used in various places)
  return window.sessionStorage.getItem('appState') === 'superUser';
};
